module.exports = __webpack_public_path__ + "static/media/pricingHeroBg3x.f7152d6d.png";